// All languages supported by the frontend
export const supportedLanguages = ['cs', 'da', 'de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt', 'sv']
